const createItem = (hash: string, title: string, extra: boolean) => {
    return `<li class="page-toc-list-item${extra ? " page-toc-list-item-extra" : ""}"><a href="#${hash}" class="page-toc-list-link">${title}</a></li>`;
}
const getTitle = (anchor) => {
    return anchor.innerHTML.length > 0 ? anchor.innerHTML : anchor.nextSibling.nodeValue.trim();
}

const main = document.querySelector('main') as HTMLElement;
const mainAnchors = [].slice.call(main.querySelectorAll('#main-content *[data-block-anchor], #main-content a[id]'));
const extraBlockAnchors = [].slice.call(main.querySelectorAll('#main-extra *[data-block-anchor], #main-extra a[id]'));
const bottomAnchors = [].slice.call(main.querySelectorAll('#main-bottom *[data-block-anchor], #main-bottom a[id]'));
const listContainers = [].slice.call(main.querySelectorAll('[data-toc-list]'));

let tocContents = "";
listContainers.forEach(container => {
    mainAnchors.forEach(anchor => {
        if (!isInsideTab(anchor)) {
            const title = getTitle(anchor);
            if (anchor.hasAttribute('data-block-anchor')) {
                anchor.id = anchor.getAttribute('data-block-anchor');
            }
            if (!anchor.hasAttribute('data-no-toc') && title != "" && anchor.id != "") {
                tocContents += createItem(anchor.id, title, false);
            }
        }
    });
    extraBlockAnchors.forEach(anchor => {
        if (!isInsideTab(anchor)) {
            const title = getTitle(anchor);
            if (anchor.hasAttribute('data-block-anchor')) {
                anchor.id = `${anchor.getAttribute('data-block-anchor')}-x`;
            }
            if (!anchor.hasAttribute('data-no-toc') && title != "" && anchor.id != "") {
                tocContents += createItem(anchor.id, title, true);
            }
        }
    });
    bottomAnchors.forEach(anchor => {
        if (!isInsideTab(anchor)) {
            const title = getTitle(anchor);
            if (anchor.hasAttribute('data-block-anchor')) {
                anchor.id = anchor.getAttribute('data-block-anchor');
            }
            if (!anchor.hasAttribute('data-no-toc') && title != "" && anchor.id != "") {
                tocContents += createItem(anchor.id, title, false);
            }
        }
    });
    container.innerHTML = tocContents;
});

function isInsideTab(anchor: HTMLElement) {
    return anchor.matches('[role="tabpanel"] *');
}